
import { defineComponent } from 'vue'
import axios from 'axios'
import Dropdown from 'primevue/dropdown'
import MultiSelect from 'primevue/multiselect'

export default defineComponent({
    name: 'scheduler-document-parameter-form',
    components: { Dropdown, MultiSelect },
    props: { propParameter: { type: Object }, roles: { type: Array }, formulas: { type: Array }, documentLabel: { type: String } },
    emits: ['loading'],
    data() {
        return {
            parameter: null as any,
            triggerStrategies: [
                { value: 'fixed', label: this.$t('managers.scheduler.fixedValuesStrategy') },
                { value: 'loadAtRuntime', label: this.$t('managers.scheduler.loadAtRuntimeStrategy') },
                { value: 'formula', label: this.$t('managers.scheduler.useFormulaStrategy') }
            ],
            triggerIterations: [
                { value: true, label: this.$t('managers.scheduler.iterateOnParameterValues') },
                { value: false, label: this.$t('managers.scheduler.doNotIterateOnParameterValues') }
            ],
            parameterValues: {} as any,
            rolesOptions: [] as any[],
            formulaOptions: [],
            loading: false
        }
    },
    watch: {
        async propParameter() {
            this.loadParameter()
            await this.formatParameter()
        },
        roles() {
            this.loadRoles()
        },
        formulas() {
            this.loadFormulas()
        }
    },
    async created() {
        this.loadRoles()
        this.loadParameter()
        await this.formatParameter()
        this.loadFormulas()
    },
    methods: {
        loadParameter() {
            this.parameter = this.propParameter as any
        },
        async formatParameter() {
            if (this.parameter.type === 'fixed') {
                await this.loadParameterValues()
                if (!this.parameterValues?.manualInput && this.parameter.value) {
                    this.parameter.manualInput = false
                    this.parameter.selectedValues = this.parameter.value.split(';').map((el: any) => el.trim())
                }
            } else if (this.parameter.type === 'loadAtRuntime' && this.parameter.value) {
                for (let i = 0; i < this.rolesOptions.length; i++) {
                    if (this.parameter.value.endsWith(this.rolesOptions[i].role)) {
                        this.parameter.value = this.rolesOptions[i].userAndRole
                        break
                    }
                }
            }
        },
        async loadParameterValues() {
            this.loading = true
            this.$emit('loading', true)
            await axios
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/documents/${this.documentLabel}/parameters/${this.parameter?.id}/values?role=${this.parameter?.role}`)
                .then((response) => (this.parameterValues = response.data))
                .catch(() => {})
            this.$emit('loading', false)
            this.loading = false
        },
        loadRoles() {
            this.rolesOptions = this.roles as any
        },
        loadFormulas() {
            this.formulaOptions = this.formulas as any
        },
        formatSelectedValues() {
            this.parameter.value = ''
            for (let i = 0; i < this.parameter.selectedValues.length; i++) {
                this.parameter.value += this.parameter.selectedValues[i]
                this.parameter.value += i === this.parameter.selectedValues.length - 1 ? ' ' : '; '
            }
        },
        async onParameterTypeChange() {
            this.parameter.value = ''
            this.parameter.selectedValues = []
            if (this.parameter.type === 'fixed') {
                await this.loadParameterValues()
            }
        }
    }
})
